import { KonfigureretContent } from '@/main/models/eforms/KonfigureretContent';
import { VisualModelNode } from '@models';
import { eformsDataUtil } from '@/main/utils/eforms-data-util';

interface SortingRule {
  groupId: string;
  priorityField: string;           // Field der angiver prioritet
  prioritySourceGroup: string;     // Gruppe der indeholder prioriteret værdier
  prioritySourceField: string;     // Felt i source gruppe der indeholder værdierne
  organizationIdField: string;     // Felt der indeholder organization
}

export class GroupSorter {
  private static readonly SORTING_RULES: SortingRule[] = [
    /** 'GR-Organisations':
     Sorteringsregel til ved patch af organisation. Specifikt skal køber oprettes først.
     Det skyldes at tjenesteyder hører ind under købere ("GR-Procedure-SProvider") er under en anden organisations ("GR-ContractingAuthority")
    */
    {
      groupId: 'GR-Organisations',
      priorityField: 'OPT-200-Organization-Company',
      prioritySourceGroup: 'GR-ContractingAuthority',
      prioritySourceField: 'OPT-300-Procedure-Buyer',
      organizationIdField: 'OPT-200-Organization-Company'
    }
  ];

  public static sortNodesIfNeeded(
    child: KonfigureretContent,
    srcVmNodes: VisualModelNode[],
    fullSourceVm: VisualModelNode
  ): void {
    const rule = this.SORTING_RULES.find(r => r.groupId === child.id);
    if (!rule) {
      return; // Spring sortering over
    }

    console.debug(`Applying sorting for ${child.id} using rule`);
    this.applySortingRule(rule, srcVmNodes, fullSourceVm);
  }

  private static applySortingRule(
    rule: SortingRule,
    srcVmNodes: VisualModelNode[],
    fullSourceVm: VisualModelNode
  ): void {
    // Find prioritet
    const prioritySourceNodes = eformsDataUtil.findAllInModel(fullSourceVm, rule.prioritySourceGroup);
    const priorityValues = prioritySourceNodes
      .map(x => x.children?.find(x => x.contentId === rule.prioritySourceField)?.value)
      .filter(x => x !== undefined && x !== '') as string[];

    // Sorter noder baseret på prioritet
    srcVmNodes.sort((a, b) => {
      const aOrgId = eformsDataUtil.findInModel(a.children!, rule.organizationIdField)?.value;
      const bOrgId = eformsDataUtil.findInModel(b.children!, rule.organizationIdField)?.value;

      const aHasPriority = aOrgId ? priorityValues.includes(aOrgId) : false;
      const bHasPriority = bOrgId ? priorityValues.includes(bOrgId) : false;

      if (aHasPriority && bHasPriority) {
        return 0;
      } else if (aHasPriority) {
        return -1; // a comes first
      } else if (bHasPriority) {
        return 1; // b comes first
      }
      return 0;
    });

    console.debug(`Sorted ${srcVmNodes.length} nodes based on priority values`);
  }
}
